import { container_classname } from "@components/new-ui/constants";
import NewLayout from "@components/new-ui/Layout";
import Image from "next/image";
import React from "react";
import { BiArrowBack } from "react-icons/bi";
import { CasestudyCard, CasestudyCardProps } from ".";
import { CaseStudyInformation, ClientFeedback, FeatureList, Navbar, navLinks, OrganizationProfile } from "./alrannan-administrative-services";
import { StatsInfoProps } from "@components/new-ui/IndustriesSection/StatsInfo";

const statsInfo: StatsInfoProps[] = [
    { percentage: "74%", label: "Increase in operational efficiency" },
    { percentage: "82%", label: "Abandoned cart recovery" },
    { percentage: "54%", label: "Reduction in customer acquisition costs" },
];

const casestudyCardsDetails: CasestudyCardProps[] = [
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/alrannan-admin-service.png",
        title: "Success Story : Improved Transparency and Increased Conversions",
        sector: "Education",
        externalLink: "/case-study/alrannan-administrative-services",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/goireland.png",
        title: "Success Story : Improved Transparency and Increased Conversions",
        sector: "Education",
        externalLink: "/case-study/goireland",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/dubai-housekeeping.png",
        title: "Gallabox transforms Dubai Housekeeping's journey to service excellence on WhatsApp",
        sector: "Service",
        externalLink: "/case-study/dubai-housekeeping",
    },
];

const Juttichoo: React.FC = () => {
    return (
        <NewLayout
            title="JuttiChoo online store | WhatsApp automation customer story"
            description="Learn how JuttiChoo, an e-commerce business, accelerated its sales cycle and improved their customer communication using Gallabox WhatsApp Business API"
            canonical="https://gallabox.com/case-study/juttichoo"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/case-study/juttichoo/juttichoo-og.png" }}
        >
            <section className="md:py-20 py-10 " style={{ background: "linear-gradient(103deg, #EDF4FF 28.71%, #D2DDFF 84.45%, #84A2FF 136.43%)" }}>
                <div className={`${container_classname} mx-auto md:flex-row flex justify-between items-center mt-5 flex-col`}>
                    <div className="md:w-1/2 w-full flex flex-col gap-y-8">
                        <a className="text-blue-500 font-medium text-lg md:flex items-center gap-x-2 hidden hover:no-underline" href={"/case-study"}>
                            <span>
                                <BiArrowBack className="hover:text-white  text-blue-500 hover:bg-blue-500 rounded-full p-1" size={30} />
                            </span>
                            Back to customer stories
                        </a>
                        <h1 className="md:text-7xl text-4xl font-bold text-left md:mb-2" style={{ fontFamily: "Degular Variable" }}>
                            How JuttiChoo boosted sales & customer engagement with Gallabox
                        </h1>
                        <p className="text-lg font-extralight tracking-wider text-left px-2 md:text-xl">
                            Find out how JuttiChoo, a well-known e-commerce platform, used Gallabox&apos;s creative solutions to lower customer acquisition costs, recover abandoned
                            carts, and streamline operations.
                        </p>
                    </div>
                    <style jsx>{`
                        .lineheight {
                            line-height: 40px;
                        }

                        @media (min-width: 768px) {
                            .lineheight {
                                line-height: 60px;
                            }
                        }
                    `}</style>

                    <Image
                        src={"https://assets.gallabox.com/gb-home/case-study/juttichoo/juttichoo-hero-image.png"}
                        height={428}
                        width={428}
                        alt="dubai-case-study"
                        className="px-2 md:px-0 mt-10 md:mt-0  rounded-xl"
                    />
                </div>
                <div className="py-10">
                    <div className={`${container_classname} grid md:grid-cols-3 grid-cols-1 justify-between px-10`}>
                        {statsInfo.map((statsInfo, idx) => (
                            <div key={idx} className="border-l-2 border-solid border-blue-500 pl-6 mb-5 md:mb-0">
                                <p style={{ fontFamily: "Degular Variable" }} className="font-bold text-new-h1">
                                    {statsInfo.percentage}
                                </p>
                                <p>{statsInfo.label}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="max-w-6xl mx-auto  md:grid md:grid-cols-6 mt-24 mb-24">
                <div className="bg-white col-span-1">
                    <div style={{ position: "sticky", top: "100px" }}>
                        <OrganizationProfile
                            companyProfileData={[
                                { label: "Company", value: ["JuttiChoo"] },
                                { label: "Industry", value: ["E-commerce"] },
                                { label: "Employees", value: ["21-50"] },
                                { label: "Team", value: ["Sales", "Support", "Marketing"] },
                            ]}
                            product={{
                                title: "Features Used",
                                productLink: [
                                    { link: "https://gallabox.com/whatsapp-chatbot", label: "WhatsApp Chatbot" },
                                    { link: "https://gallabox.com/whatsapp-integrations/shopify", label: "Shopify Integration" },
                                    { link: "https://gallabox.com/whatsapp-broadcast", label: "WhatsApp Broadcasts" },
                                    { link: "https://gallabox.com/whatsapp-integrations/razorpay", label: "Razorpay Integration" },
                                    { link: "https://gallabox.com/whatsapp-drip-marketing", label: "Drip Marketing (Sequences)" },
                                ],
                            }}
                        />
                    </div>
                </div>
                <div className=" col-span-4 md:pl-8 px-4">
                    <div className="flex flex-col gap-y-12">
                        <section id="About">
                            <CaseStudyInformation mainTitle={"JuttiChoo is where tradition meets trend"} className="mt-0" />
                            <p className="mt-2">
                                JuttiChoo, a popular online retailer specializing in handcrafted shoes, faced some tough challenges as they scaled. Payments were getting
                                complicated, customers were abandoning carts, and traditional SMS and email marketing just weren&apos;t cutting it anymore.
                            </p>
                            <p className="mt-5">
                                They needed a fresh approach to connect with their audience, recover lost sales, and simplify operations. That&apos;s when Gallabox stepped in to
                                help, and the results were nothing short of remarkable.
                            </p>
                        </section>

                        <section id="Challenges">
                            <CaseStudyInformation
                                subTitle={"Challenges in traditional communication channels"}
                                descriptions={["JuttiChoo faced several roadblocks in their customer journey:"]}
                                className="mt-0"
                            />
                            <FeatureList
                                List={[
                                    { listItem: "Complicated payments, leading to drop-offs" },
                                    { listItem: "High cart abandonment rates with no easy way to recover lost sales" },
                                    { listItem: "Traditional SMS & email marketing — no longer enough to help meet business targets." },
                                ]}
                                className="mt-4 bg-gray-100"
                            />
                            <p className="mt-5">As JuttiChoo expanded, they encountered several challenges:</p>
                            <CaseStudyInformation
                                subTitle={"Integration issues with Razorpay"}
                                descriptions={[
                                    "Inability to connect payment gateways smoothly hampered transaction procedures (to maintain consistency with the other two points)",
                                ]}
                                className="mt-10"
                            />
                            <CaseStudyInformation
                                subTitle={"Abandoned cart recovery"}
                                descriptions={["Lack of an effective strategy to re-engage customers who left after adding items to their carts."]}
                                className="mt-10"
                            />
                            <CaseStudyInformation
                                subTitle={"Overdependence on SMS and emails"}
                                descriptions={[
                                    "Decrease in customer engagement rates due to the ineffectiveness of traditional channels.",
                                    "They needed a solution that could integrate smoothly with their existing systems and provide a direct line of communication with their customers.",
                                ]}
                                className="mt-10"
                            />
                        </section>

                        <section id="Solutions">
                            <CaseStudyInformation subTitle={"Why Gallabox Was the Perfect Fit"} className="mt-0" />
                            <p className="mt-2">
                                After trying out different tools, JuttiChoo turned to Gallabox because it offered everything they needed: automation, seamless integrations, and
                                scalable communication tools. Here&apos;s how Gallabox made a difference:
                            </p>

                            <p className="text-xl font-medium mt-6">Smart automation</p>
                            <FeatureList
                                List={[
                                    { listItem: "A WhatsApp chatbot for instant customer support." },
                                    { listItem: "Automated abandoned cart recovery messages that brought back lost sales." },
                                    { listItem: "Real-time Razorpay payment updates via WhatsApp for smoother transactions." },
                                ]}
                                className="mt-5 bg-gray-100"
                            />

                            <p className="text-xl font-medium mt-6">Seamless integrations</p>
                            <FeatureList
                                List={[
                                    { listItem: "Shopify integration to sync customer profiles and their respective order details effortlessly." },
                                    { listItem: "Razorpay connection for instant transaction alerts." },
                                    { listItem: "A unified team inbox for managing all customer conversations in one place." },
                                ]}
                                className="mt-5 bg-gray-100"
                            />

                            <p className="text-xl font-medium mt-6">Scalable engagement tools</p>
                            <FeatureList
                                List={[
                                    { listItem: "WhatsApp broadcasts to send personalized promotions directly to customers." },
                                    { listItem: "Drip marketing campaigns to nurture leads over time." },
                                    { listItem: "Order confirmations and updates via WhatsApp for a frictionless shopping experience." },
                                ]}
                                className="mt-5 bg-gray-100"
                            />
                        </section>

                        <section id="Impact">
                            <CaseStudyInformation
                                subTitle={"The Impact: Numbers that speak for themselves"}
                                descriptions={["Gallabox didn't just solve JuttiChoo's problems; it transformed their operations entirely:"]}
                                className="mt-0"
                            />
                            <p className="text-xl font-medium mt-6">82% abandoned cart recovery</p>
                            <FeatureList
                                List={[
                                    { listItem: "Automated WhatsApp reminders re-engaged customers" },
                                    { listItem: "Purchases are completed without manual effort" },
                                    { listItem: "Upsell offers increased cart value" },
                                ]}
                                className="mt-4 bg-gray-100"
                            />
                            <p className="text-xl font-medium mt-6">74% increase in operational efficiency</p>
                            <FeatureList
                                List={[
                                    { listItem: "Manual work drastically reduced" },
                                    { listItem: "Centralized communication boosted speed" },
                                    { listItem: "Faster workflows, happier teams" },
                                ]}
                                className="mt-4 bg-gray-100"
                            />
                            <p className="text-xl font-medium mt-6">54% reduction in customer acquisition costs:</p>
                            <FeatureList
                                List={[
                                    { listItem: "Targeted campaigns outperformed paid ads" },
                                    { listItem: "Personalized outreach improved conversions" },
                                    { listItem: "Lower spend, better lead quality" },
                                ]}
                                className="mt-4 bg-gray-100"
                            />
                            <CaseStudyInformation
                                subTitle={"What's next for JuttiChoo?"}
                                descriptions={["With Gallabox as a core part of their strategy, JuttiChoo is continuing to innovate:"]}
                                className="mt-10"
                            />
                            <FeatureList
                                List={[
                                    { listItem: "Expanding WhatsApp marketing campaigns to reach even more customers." },
                                    { listItem: "Personalizing interactions further using advanced automation." },
                                    { listItem: "Optimizing payment systems and order tracking for an even better shopping experience." },
                                ]}
                                className="mt-4 bg-gray-100"
                            />

                            <ClientFeedback
                                descriptions={
                                    <p className="text-gray-900 italic font-semibold px-6 mb-4">&quot;The setup process with Gallabox was remarkably smooth and quick!&quot;</p>
                                }
                                authorName="Rupesh Sule"
                                designationWithServiceName=" Founder, JuttiChoo"
                                className="border-blue-500 bg-gray-100  my-5"
                            />

                            <p className="mt-5">
                                JuttiChoo&apos;s success story is proof that embracing smart automation and direct communication tools like WhatsApp can revolutionize how
                                businesses engage with customers. By partnering with Gallabox, they&apos;ve unlocked new levels of efficiency, satisfaction, and growth in the
                                e-commerce space.
                            </p>
                        </section>
                    </div>
                </div>
                <div>
                    <div style={{ position: "sticky", top: "100px", minHeight: "510px" }} className="hidden md:block">
                        <Navbar links={navLinks} />
                    </div>
                </div>
            </section>
            <div className="max-w-6xl mx-auto">
                <div>
                    <h3 className="text-gray-900 max-w-6xl mx-auto mb-10 ml-4 mt-5 text-center md:text-left">Keep exploring stories like this.</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto gap-10 mb-20">
                        {casestudyCardsDetails?.map((data, index) => (
                            <CasestudyCard key={index} {...data} />
                        ))}
                    </div>
                </div>
            </div>
        </NewLayout>
    );
};

export default Juttichoo;
